/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'en';
const locales = ['en'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: 'HigherEdJobLine',
    SITE_DESCRIPTION: 'Explore HigherEdJobLine.com to find the top career opportunities and the best in higher ed jobs. Connect with the leading job board focused on higher education jobs and take the next step in your academic career.',
    SUBSCRIPTIONS_FEATURE_ACTIVE: true,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    NEWSLETTER_FEATURE_ACTIVE: true,
    SHOW_GA4_STATISTICS: false,
    ASSETS: {
      logo: '/static/higheredjobline/logo.png',
      loginImage: '/static/higheredjobline/login-banner.jpg',
      faviconsPath: '/static/higheredjobline',
    },
    OG_IMAGE: '/static/higheredjobline/og-image.jpg',
    THEME: {
      colors: {
        primary: '#050a30',
      },
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      location: { lat: 39.810106, lng: -98.557822 },
      radius: 500,
    },
    EURO_VAT_SYSTEM: false,
    GA4_MEASUREMENT_IDS: ['G-PNS1657KXK', 'G-99XKS90S8S'],
    PRICE_CONFIG: {
      CURRENCY_PLACEMENT: 'before',
    },
    GTM_CONTAINER_ID: 'AW-16698017374',
  },
});
